module.exports = __webpack_public_path__ + "img/24.26d84ab7.png";